import { getProductBySlug } from '@data/products';
import { getProductVariant, resolveProductVariant } from '@utils/productVariants';
export const checkoutPath = (product, variantId) => {
    const params = new URLSearchParams({ product: product.slug });
    if (variantId)
        params.set('variant', variantId);
    return `/checkout?${params.toString()}`;
};
export const resolveCheckoutSelection = (productSlug, variantId) => {
    if (!productSlug)
        return undefined;
    const product = getProductBySlug(productSlug);
    if (!product)
        return undefined;
    const selected = resolveProductVariant(product, variantId || undefined);
    if (!selected)
        return undefined;
    const variant = getProductVariant(product, variantId || undefined);
    return {
        product: selected,
        ...(variant ? { variantId: variant.id, durationMonths: variant.durationMonths } : {}),
        quantity: 1
    };
};
export const acceptanceRequirements = (fulfilmentType) => ({
    terms: true,
    immediateService: fulfilmentType === 'service',
    immediateDigital: fulfilmentType === 'digital-content'
});
export const validateAcceptance = (fulfilmentType, values) => {
    const required = acceptanceRequirements(fulfilmentType);
    return {
        terms: required.terms && !values.termsAccepted,
        immediateService: required.immediateService && !values.immediateServiceAccepted,
        immediateDigital: required.immediateDigital && !values.immediateDigitalAccepted
    };
};
export const validateClientDetails = (values) => {
    const fullName = values.fullName.trim();
    const email = values.email.trim();
    const phone = values.phone.trim();
    const phoneDigits = phone.replace(/\D/g, '');
    return {
        fullName: fullName.length < 2 || fullName.length > 120,
        email: email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
        phone: phone.length > 40 ||
            !/^[+()\d\s.-]+$/.test(phone) ||
            phoneDigits.length < 7 ||
            phoneDigits.length > 15
    };
};
